import { Button, Col, Descriptions, Divider, Flex, Form, Image, Input, message, Modal, Row, Select, Steps, Typography, Upload } from "antd"
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import pallete from "../../../utils/pallete";
import RenderIf from "../../../components/RenderIf";
import UploadFile from "../../../components/UploadFile";
import { canUploadImage } from "../../../utils/imageValidator";
import { MAX_FILE_SIZE } from "../../../utils/const";
import { useMutation, useQuery } from "@tanstack/react-query";
import { rccService } from "../../../services/rcc.service";
import { API_BASE_URL } from "../../../config/api.config";

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

const preprocessUpload = async (file) => {
  file.preview = await getBase64(file)
  if(!canUploadImage(file.name)){
    message.error(`Format file tidak benar`);
    return Upload.LIST_IGNORE; // 
  }
  // if (file.size > MAX_FILE_SIZE) {
  //   message.error(`File tidak boleh lebih dari ${MAX_FILE_SIZE / 1024 / 1024} MB`);
  //   return Upload.LIST_IGNORE;
  // }
}

// eslint-disable-next-line react/prop-types
const RccForm = forwardRef(({ registrationStatus, userSubdivision, registrationId, onSuccessVerify, rejectionData = {} }, ref) => {

  const [form] = Form.useForm()
  const [rejectForm] = Form.useForm()
  
  
  const [modalApi,modalHolder] = Modal.useModal()
  const [filePreview, setFilePreview] = useState()
  const [rejectModal, setRejectModal] = useState(false)
  const [stepPosition, setStepPosition] = useState(0);
  const [docs, setDocs] = useState({
    additional: [],
    network: [],
    modellingReport: [],
    meterSizing: [],
    ded: [],
    proposal: [],
    pesanan : [],
    izinTerbit: [],
    bast: [],
    sppk: [],
    mc100: []
  })

  const droWatch = Form.useWatch('droId', form)

  const { data: formDetail } = useQuery({
    queryKey: ['form'],
    queryFn: () => rccService.getForm(registrationId),
    enabled: !!registrationStatus,
    select: ({ data }) => data
  })

  const { data: documents } = useQuery({
    queryKey: ['documents', formDetail],
    queryFn: () => rccService.getDocuments(formDetail?.id),
    enabled: !!registrationStatus && !!formDetail,
    select: ({ data }) => data
  })


  useEffect(() => {
    if(formDetail){
      setStepPosition(formDetail?.step-1)
    }
    if(registrationStatus && formDetail){
      form.setFieldsValue(formDetail)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDetail, registrationStatus])

  useEffect(() => {
    if(documents){
      setDocs({
        additional: documents?.additionalLetter.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        network: documents?.network?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        modellingReport: documents?.modellingReport?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        meterSizing: documents?.meterSizing?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        ded: documents?.ded?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        proposal: documents?.proposal?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        pesanan : documents?.pesanan?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        izinTerbit: documents?.izinTerbit?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        bast: documents?.bast?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        sppk: documents?.sppk?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        })),
        mc100: documents?.mc100?.map(e => ({
          ...e,
          name: e.fileName,
          size: e.fileSize,
          preview: `${API_BASE_URL}/files/${e.filePath}`
        }))
      })
    }
  }, [documents])

  const verifyMutation = useMutation({
    mutationFn: (data) => rccService.verify(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchDistributionOfficerMutation = useMutation({
    mutationFn: (data) => rccService.dispatchDistributionOfficer(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
    },
    onError: (err) => {
      alert(err)
    }
  })
  
  const dispatchModellingOfficerMutation = useMutation({
    mutationFn: (data) => rccService.dispatchModellingOfficer(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchMeterSizingMutation = useMutation({
    mutationFn: (data) => rccService.dispatchMeterSizing(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchDistributionDROMutation = useMutation({
    mutationFn: (data) => rccService.dispatchDistributionDRO(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchPEPMDocumentDEDMutation = useMutation({
    mutationFn: (data) => rccService.dispatchPEPMDocumentDED(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchRccOfficerProposalMutation = useMutation({
    mutationFn: (data) => rccService.dispatchRccOfficerProposal(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchRccOfficerAdministrasiToRccMutation = useMutation({
    mutationFn: (data) => rccService.dispatchRccOfficerAdministrasiToRcc(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchPEPMInstallationMutation = useMutation({
    mutationFn: (data) => rccService.dispatchPEPMInstallation(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const dispatchMeterInstallationMutation = useMutation({
    mutationFn: (data) => rccService.dispatchMeterInstallation(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
    },
    onError: (err) => {
      alert(err)
    }
  })

  const rejectMutation = useMutation({
    mutationFn: (data) => rccService.reject(registrationId, data),
    onSuccess: () => {
      onSuccessVerify()
      message.success("Data berhasil disubmit")
      setRejectModal(false)
    },
    onError: (err) => {
      alert(err)
    }
  })

  const addFile = (type, file) => {
    setDocs({ ...docs, [type]: [...docs[type], file] })
  }

  const removeFile = (type, file) => {
    setDocs({
      ...docs, 
      [type]: docs[type].filter(e => e.uid != file.uid)
    })
  }

  const verifyRcc = () => {
    validateFields().then( values => {
      verifyMutation.mutate(values)
    })
  }

  const nextStep = () => stepPosition < 9 && setStepPosition(stepPosition + 1) 

  const validateFields = async () => {
    if(stepPosition == 0){
      const values = await form.validateFields(['ccTeamNote', 'filingProcessOptions'])
      return {...values, additional: docs.additional }
    }
  }

  const dispatchDistributionOfficer = async () => {
    const fields = await form.validateFields(['diameter', 'streetName', 'paPc', 'idModellingRequest', 'waterPressure'])
    const values = {...fields, network: docs.network }
    if(docs.network.length <= 0){
      message.error("Dokumen Jaringan harus diunggah")
      return
    } 
    dispatchDistributionOfficerMutation.mutate(values)
  }

  const dispatchModellingReport = async () => {
    const fields = await form.validateFields(['mrNumber', 'waterPressureConfirmation'])
    const values = {...fields, modellingReport: docs.modellingReport }
    if(docs.modellingReport.length <= 0){
      message.error("Modelling Report harus diunggah")
      return
    } 
    dispatchModellingOfficerMutation.mutate(values)
  }

  const dispatchMeterSizing = async () => {
    if(docs.meterSizing.length <= 0){
      message.error("Meter Sizing Report harus diunggah")
      return
    } 
    dispatchMeterSizingMutation.mutate({ meterSizing: docs.meterSizing })
  }

  const dispatchDistributionDRO = async () => {
    const fields = await form.validateFields(['droId'])
    modalApi.confirm({
      title:"Pemberitahuan",
      content: "Yakin untuk melanjutkan proses ?",
      centered: true,
      onOk: () => dispatchDistributionDROMutation.mutate(fields)
    })
  }

  const dispatchPEPMDocumentDED = async () => {
    if(docs.ded.length <= 0){
      message.error("Dokumen DED & RAB harus diunggah")
      return
    } 
    modalApi.confirm({
      title:"Pemberitahuan",
      content: "Yakin untuk melanjutkan proses ?",
      centered: true,
      onOk: () => dispatchPEPMDocumentDEDMutation.mutate({ files: docs.ded })
    })
  }

  const dispatchRccOfficerProposal = async () => {
    const fields = await form.validateFields(['proposalExpiryDate'])
    if(docs.proposal.length <= 0){
      message.error("Dokumen proposal harus diunggah")
      return
    } 
    modalApi.confirm({
      title:"Pemberitahuan",
      content: "Yakin untuk melanjutkan proses ?",
      centered: true,
      onOk: () => dispatchRccOfficerProposalMutation.mutate({ ...fields, files: docs.proposal })
    })
  }

  const dispatchRccOfficerAdministrasiToRcc = async () => {
    const fields = await form.validateFields(['proNumber'])
    if(docs.pesanan.length <= 0){
      message.error("Surat pesanan harus diunggah")
      return
    } 
    modalApi.confirm({
      title:"Pemberitahuan",
      content: "Yakin untuk melanjutkan proses ?",
      centered: true,
      onOk: () => dispatchRccOfficerAdministrasiToRccMutation.mutate({ ...fields, files: docs.pesanan })
    })
  }

  const dispatchPEPMInstallation = async () => {
    if(docs.izinTerbit.length <= 0){
      message.error("Dokumen izin terbit harus diunggah")
      return
    } 
    if(docs.bast.length <= 0){
      message.error("BAST pemsangan jaringan harus diunggah")
      return
    } 
    modalApi.confirm({
      title:"Pemberitahuan",
      content: "Yakin untuk melanjutkan proses ?",
      centered: true,
      onOk: () => dispatchPEPMInstallationMutation.mutate({ izinTerbit: docs.izinTerbit, bast: docs.bast })
    })
  }

  const dispatchMeterInstallation = async () => {
    const fields = await form.validateFields(['caseId', 'faId', 'nomen'])
    if(docs.sppk.length <= 0){
      message.error("SPPK harus diunggah")
      return
    } 
    if(docs.mc100.length <= 0){
      message.error("MC 100 harus diunggah")
      return
    } 
    modalApi.confirm({
      title:"Pemberitahuan",
      content: "Yakin untuk melanjutkan proses ?",
      centered: true,
      onOk: () => dispatchMeterInstallationMutation.mutate({ ...fields, sppk: docs.sppk, mc100: docs.mc100 })
    })
  }
  
  const handleReject = () => {
    rejectForm.setFieldsValue({
      cancelAtStep: formDetail?.step || 1,
      cancelAtStatus: registrationStatus
    })
    setRejectModal(true)
  }

  const handlePreviewDRO = () => {
    window.open(`https://engineering.pamjaya.co.id:4793/${droWatch}`, '_blank', 'noopener,noreferrer');
  }

  const handleSubmitReject = (values) => rejectMutation.mutate(values)

  useImperativeHandle(ref, () => ({
    verifyRcc,
    nextStep,
    dispatchDistributionOfficer
  }))

  return (
    <>
      {modalHolder}
      <Row>
        <Col flex={1} style={{ paddingRight: 20 }} > 
          <Form
            layout="vertical"
            form={form}
          >
            {/* Corporate Customer */}
            <RenderIf when={stepPosition == 0} >
              <Form.Item name={'ccTeamNote'} label="Catatan Tim CC" rules={[{ required: true }]} >
                <Input.TextArea 
                  disabled={userSubdivision != 'RCC Officer' || registrationStatus != 'Verifikasi'} 
                />
              </Form.Item>
              <Form.Item name={'filingProcessOptions'} label="Pilihan Proses Pemberkasan" >
                <Select
                  disabled={userSubdivision != 'RCC Officer' || registrationStatus != 'Verifikasi'}
                  options={['Dengan ABJ', 'Reguler'].map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <UploadFile
                title={'Dokumen Tambahan'}
                fileList={docs.additional}
                disabled={registrationStatus != 'Verifikasi' && (userSubdivision != 'RCC Officer') || registrationStatus == 'Ditolak'}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('additional', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('additional', file)}
                activeDelete={registrationStatus == 'Verifikasi'}
              />
              <RenderIf when={registrationStatus == 'Verifikasi' && userSubdivision == 'RCC Officer'} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={verifyMutation.isPending} disabled={verifyMutation.isPending} onClick={handleReject} variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button loading={verifyMutation.isPending} disabled={verifyMutation.isPending} onClick={verifyRcc} variant="solid" color="primary" >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Distribusi */}
            <RenderIf when={stepPosition == 1} >
              <UploadFile
                title={'Dokumen Jaringan'}
                fileList={docs.network}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('network', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('network', file)}
                disabled={(registrationStatus != 'Studi Kesanggupan') || (userSubdivision != 'Distribution Officer')}
                activeDelete={registrationStatus == 'Studi Kesanggupan'}
              />
              <Form.Item name={'diameter'} label="Primer/Sekunder/Tersier Diameter (mm)" rules={[{ required: true }]} >
                <Input disabled={registrationStatus != 'Studi Kesanggupan'} />
              </Form.Item>
              <Form.Item name={'streetName'} label="Nama Jalan" rules={[{ required: true }]} >
                <Input disabled={registrationStatus != 'Studi Kesanggupan'} />
              </Form.Item>
              <Form.Item name={'paPc'} label="PA/PC" rules={[{ required: true }]} >
                <Input disabled={registrationStatus != 'Studi Kesanggupan'} />
              </Form.Item>
              <Form.Item name={'idModellingRequest'} label="No. ID Modelling Request" rules={[{ required: true }]} >
                <Input disabled={registrationStatus != 'Studi Kesanggupan'} />
              </Form.Item>
              <Form.Item name={'waterPressure'} label="Tekanan Air" rules={[{ required: true }]} >
                <Select
                  disabled={registrationStatus != 'Studi Kesanggupan'}
                  options={['<2 Meter', '2-5 Meter', '>5 Meter'].map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <RenderIf when={registrationStatus == 'Studi Kesanggupan' && userSubdivision == 'Distribution Officer'} > 
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={dispatchDistributionOfficerMutation.isPending} disabled={dispatchDistributionOfficerMutation.isPending} variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button loading={dispatchDistributionOfficerMutation.isPending} disabled={dispatchDistributionOfficerMutation.isPending} onClick={dispatchDistributionOfficer} variant="solid" color="primary" >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Modelling */}
            <RenderIf when={stepPosition == 2} >
              <UploadFile
                title={'Modelling Report'}
                fileList={docs.modellingReport}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('modellingReport', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('modellingReport', file)}
                activeDelete={formDetail?.step == 3}
                disabled={formDetail?.step != 3} 
              />
              <Form.Item name={'mrNumber'} rules={[{ required: true }]} label="MR Number" >
                <Input disabled={formDetail?.step != 3} />
              </Form.Item>
              <Form.Item name={'waterPressureConfirmation'} label="Konfirmasi Tekanan Air" rules={[{ required: true }]} >
                <Select
                  disabled={formDetail?.step != 3}
                  options={['<2 Meter', '2-5 Meter', '>5 Meter'].map(e => ({ label: e, value: e }))}
                />
              </Form.Item>
              <RenderIf when={userSubdivision == 'Modelling Officer'} > 
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={dispatchModellingOfficerMutation.isPending} disabled={dispatchModellingOfficerMutation.isPending} variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button 
                    loading={dispatchModellingOfficerMutation.isPending} disabled={dispatchModellingOfficerMutation.isPending} 
                    onClick={() => {
                      modalApi.confirm({
                        title:"Pemberitahuan",
                        content: "Yakin untuk melanjutkan proses ?",
                        centered: true,
                        onOk: dispatchModellingReport
                      })
                    }} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Meter Sizing */}
            <RenderIf when={stepPosition == 3} >
              <UploadFile
                title={'Meter Sizing Report'}
                fileList={docs.meterSizing}
                disabled={formDetail?.step != 4}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('meterSizing', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('meterSizing', file)}
                activeDelete={formDetail?.step == 4}
              />
              <RenderIf when={userSubdivision == 'Operation Study' && formDetail?.step == 4} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={dispatchMeterSizingMutation.isPending} disabled={dispatchMeterSizingMutation.isPending}  variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button   
                    loading={dispatchMeterSizingMutation.isPending} disabled={dispatchMeterSizingMutation.isPending} 
                    onClick={() => {
                      modalApi.confirm({
                        title:"Pemberitahuan",
                        content: "Yakin untuk melanjutkan proses ?",
                        centered: true,
                        onOk: dispatchMeterSizing
                      })
                    }} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Distribusi */}
            <RenderIf when={stepPosition == 4} >
              <Form.Item label="DRO ID" name={'droId'} rules={[{ required: true }]} >
                <Input 
                  disabled={formDetail?.step != 5} 
                  suffix={<Button disabled={!droWatch} onClick={handlePreviewDRO} variant="outlined" color="primary" >Preview</Button>} 
                />
              </Form.Item>
              <RenderIf when={userSubdivision == 'Distribution Officer' && formDetail?.step == 5} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={dispatchDistributionDROMutation.isPending} disabled={dispatchDistributionDROMutation.isPending}  variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button 
                    loading={dispatchDistributionDROMutation.isPending} disabled={dispatchDistributionDROMutation.isPending} 
                    onClick={dispatchDistributionDRO} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* PEPM */}
            <RenderIf when={stepPosition == 5} >
              <UploadFile
                title={'Dokumen DED & RAB'}
                fileList={docs.ded}
                disabled={formDetail?.step != 6}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('ded', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('ded', file)}
                activeDelete={formDetail?.step == 6 }
              />
              <RenderIf when={userSubdivision == 'PEPM Officer' && formDetail?.step == 6} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={dispatchPEPMDocumentDEDMutation.isPending} disabled={dispatchPEPMDocumentDEDMutation.isPending} variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button 
                    loading={dispatchPEPMDocumentDEDMutation.isPending} disabled={dispatchPEPMDocumentDEDMutation.isPending} 
                    onClick={dispatchPEPMDocumentDED} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Dokumen Proposal */}
            <RenderIf when={stepPosition == 6} >
              <UploadFile
                title={'Proposal Sambungan Baru CC'}
                fileList={docs.proposal}
                disabled={formDetail?.step != 7}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('proposal', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('proposal', file)}
                activeDelete={formDetail?.step == 7 }
              />
              <Form.Item name={'proposalExpiryDate'} rules={[{ required: true }]} label="Expiry Date" >
                <Input type="date" disabled={formDetail?.step != 7} />
              </Form.Item>
              <RenderIf when={userSubdivision == 'RCC Officer' && formDetail?.step == 7} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button loading={dispatchRccOfficerProposalMutation.isPending} disabled={dispatchRccOfficerProposalMutation.isPending}  variant="outlined" color="danger" >
                    Tolak
                  </Button>
                  <Button 
                    loading={dispatchRccOfficerProposalMutation.isPending} disabled={dispatchRccOfficerProposalMutation.isPending} 
                    onClick={dispatchRccOfficerProposal} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Administrasi To RCC */}
            <RenderIf when={stepPosition == 7} >
              <Form.Item label="No Pro" rules={[{ required: true }]} name={'proNumber'} >
                <Input disabled={formDetail?.step != 8} />
              </Form.Item>
              <UploadFile
                title={'Surat Pesanan / Cover Letter dan Kwitansi Pembayaran'}
                fileList={docs.pesanan}
                disabled={formDetail?.step != 8}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('pesanan', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('pesanan', file)}
                activeDelete={formDetail?.step == 8 }
              />
              <RenderIf when={userSubdivision == 'RCC Officer' && formDetail?.step == 8} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button 
                    loading={dispatchRccOfficerAdministrasiToRccMutation.isPending} disabled={dispatchRccOfficerAdministrasiToRccMutation.isPending} 
                    onClick={dispatchRccOfficerAdministrasiToRcc} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Pemasangan oleh PEPM */}
            <RenderIf when={stepPosition == 8} >
              <UploadFile
                title={'Dokumen Izin Terbit'}
                fileList={docs.izinTerbit}
                disabled={formDetail?.step != 9}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('izinTerbit', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('izinTerbit', file)}
                activeDelete={formDetail?.step == 9}
              />
              <UploadFile
                title={'BAST Pemasangan jaringan'}
                fileList={docs.bast}
                disabled={formDetail?.step != 9}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('bast', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('bast', file)}
                activeDelete={formDetail?.step == 9}
              />
              <RenderIf when={userSubdivision == 'PEPM Officer' && formDetail?.step == 9} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button 
                    loading={dispatchPEPMInstallationMutation.isPending} disabled={dispatchPEPMInstallationMutation.isPending} 
                    onClick={dispatchPEPMInstallation} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>
            {/* Pemasangan Meter CC */}
            <RenderIf when={stepPosition == 9} >
              <UploadFile
                title={'SPPK Pemasangan Meter'}
                fileList={docs.sppk}
                disabled={formDetail?.step != 10 || registrationStatus == 'Terpasang'}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('sppk', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('sppk', file)}
                activeDelete={formDetail?.step == 10 && registrationStatus != 'Terpasang'}
              />
              <UploadFile
                title={'MC 100'}
                fileList={docs.mc100}
                disabled={formDetail?.step != 10 || registrationStatus == 'Terpasang'}
                beforeUpload={async (file) => {
                  await preprocessUpload(file)
                  addFile('mc100', file)
                }}
                onPreview={(file) => setFilePreview(file.preview)}
                onRemove={(file) => removeFile('mc100', file)}
                activeDelete={formDetail?.step == 10 && registrationStatus != 'Terpasang'}
              />
              <Form.Item name={'caseId'} label="Case ID/Order ID" rules={[{ required: true }]} >
                <Input disabled={((formDetail?.step-1) != stepPosition) || registrationStatus == 'Terpasang'} />
              </Form.Item>
              <Form.Item name={'faId'} label="No. FA ID (SIMPEL/CCNB)" rules={[{ required: true }]} >
                <Input disabled={((formDetail?.step-1) != stepPosition) || registrationStatus == 'Terpasang'}  />
              </Form.Item>
              <Form.Item name={'nomen'} rules={[{ required: true }]} label="NOMEN/NOREK (SIMPEL/CCNB)" >
                <Input disabled={((formDetail?.step-1) != stepPosition) || registrationStatus == 'Terpasang'}  />
              </Form.Item>
              <RenderIf when={userSubdivision == 'RCC Officer' && formDetail?.step == 10 && registrationStatus != 'Terpasang'} > 
                <Divider/>
                <Flex justify="flex-end" gap={20} >  
                  <Button 
                    loading={dispatchMeterInstallationMutation.isPending} disabled={dispatchMeterInstallationMutation.isPending} 
                    onClick={dispatchMeterInstallation} 
                    variant="solid" 
                    color="primary" 
                  >
                    Dispatch
                  </Button>
                </Flex>
              </RenderIf>
            </RenderIf>

            <RenderIf when={registrationStatus == 'Ditolak' && stepPosition == (rejectionData?.cancelAtStep - 1)} >
              <Divider orientation="left" >
                Informasi Penolakan
              </Divider>
              <Descriptions
                bordered
                size="small"
                column={2}
                items={[
                  {
                    label: 'Dicancel Oleh',
                    children: rejectionData?.actor
                  },
                  {
                    label: 'Waktu cancel',
                    children: rejectionData?.date
                  },
                  {
                    label: 'Alasan Cancel',
                    children: rejectionData?.reason
                  },
                ]}
              />
            </RenderIf>
          </Form>
        </Col>
        <Col flex={'250px'} style={{ borderLeft: '.5px solid ' + pallete.grey[400], paddingLeft: 20 }} > 
          <Steps
            current={stepPosition}
            onChange={(val) => {
              // if(!registrationStatus) return
              setStepPosition(val)
            }}
            items={[
              {
                title: <Typography.Text>Corporate Customer</Typography.Text>,
              },
              {
                title: <Typography.Text>Distribusi</Typography.Text>,
              },
              {
                title: <Typography.Text>Modelling</Typography.Text>,
              },
              {
                title: <Typography.Text>Meter Sizing</Typography.Text>,
              },
              {
                title: <Typography.Text>Distribusi</Typography.Text> ,
              },
              {
                title: <Typography.Text >PEPM</Typography.Text>,
              },
              {
                title: <Typography.Text >Dokumen Proposal</Typography.Text>,
              },
              {
                title: <Typography.Text>Administrasi To RCC</Typography.Text> ,
              },
              {
                title: <Typography.Text>Konstruksi oleh PEPM</Typography.Text> ,
              },
              {
                title: <Typography.Text>Pemasangan Meter CC</Typography.Text> ,
              }
            ]}
            direction="vertical"
            style={{ height: 580 }}
          />
        </Col>
      </Row>
      <Modal 
        title="Preview File"
        open={filePreview} 
        onClose={() => setFilePreview(null)}
        onCancel={() => setFilePreview(null)}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setFilePreview(null)}>
            Cancel
          </Button>
        ]}
      >
        <Image src={filePreview} />
      </Modal>
      <Modal
        open={rejectModal}
        centered
        title="Konfirmasi Penolakan"
        onOk={rejectForm.submit}
        okButtonProps={{
          loading: rejectMutation.isPending
        }}
        cancelButtonProps={{
          loading: rejectMutation.isPending
        }}
        onCancel={() => {
          rejectForm.resetFields()
          setRejectModal(false)
        }}
      >
        <Form
          form={rejectForm}
          layout="vertical"
          onFinish={handleSubmitReject}
        >
          <Row gutter={[20]} >
            <Col span={12} >
              <Form.Item
                name="cancelAtStep"
                label="Dicancel pada step"
              >
                <Input readOnly style={{ backgroundColor: pallete.grey[200] }} />
              </Form.Item>
            </Col>
            <Col span={12} >
              <Form.Item
                name="cancelAtStatus"
                label="Dicancel pada status"
              >
                <Input readOnly style={{ backgroundColor: pallete.grey[200] }} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            label="Alasan Cancel"
            name={'reason'}
            rules={[{ required: true }]}
          >
            <Input.TextArea/>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )

})

RccForm.displayName = 'RccForm';

export default RccForm